import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import StatusList from "../screens/masters/genericmaster/StatusList";
import queryString from "query-string";

const Home = props => {
  const values = queryString.parse(props.location.search);
  const breadCrumbData = [
    { link: "/masters-list", name: "Masters" },
    { link: "/master-profile", name: "Generic Master" },
    {
      link: `/status-list?id=${values.id}&name=${values.name}`,
      name: values.name
    }
  ];
  return (
    <>
      <LayoutContainer>
        <BreadCrumb data={breadCrumbData} />
        <StatusList />
      </LayoutContainer>
    </>
  );
};

export default Home;
